import { defineStore } from "pinia";
import { useRouter } from "vue-router";
import { getActiveDatabase } from "../helpers/databaseMapping";

export const useShowComponentsStore = defineStore("showComponents", {
  state: () => ({
    isLoginPage: false, // Stato per controllare se ci troviamo nella pagina di login
  }),
  actions: {
    checkRoute() {
      const router = useRouter();
      // Controlla se l'utente si trova nella route "/login"
      this.isLoginPage = router.currentRoute.value.name === "Login";
      if (this.isLoginPage) {
        return false;
      }
      return true;
    },
    generateHistoryUrl(round_id, token) {
      let gameID = getActiveDatabase();
    

      let prefix = "https://stage-casino.theearplatform.com/";
      let link = `${prefix}moregames/historyPage/?round_id=${round_id}&game_id=${gameID}&token=${token}`;
      setTimeout(() => {
        window.open(link, "_blank");
      });
    },
  },
});
